/**
 * Will create a ToolTip
 * The ToolTip will have a QuestionMark icon and could be
 * personalized with the parameters below.
 *
 * @param {string} position             [The horizontal position of the ToolTip: 'right' or 'left']
 * @param {string} verticalPosition     [The vertical position of the ToolTip: 'top' or 'bottom']
 * @param {ReactDOM} child              [Description of the ToolTip, would be the child]
 */

/**
 * Import
 * - Libraries
 */
import * as React from 'react'

/**
 * Import
 * - Images
 */
import { InfoIcon } from '../../../images/icons/Info/Info'
import { BinIcon } from '../../../images/icons/Bin/Bin'

/**
 * Import
 * - CSS
 */
import './styles/ToolTip.css'

/**
 * ToolTip class
 *
 * @export
 * @class ToolTip
 * @extends {React.Component<any, any>}
 */
export default class ToolTip extends React.Component<any, any> {

    /**
     * Creates an instance of ToolTip.
     *
     * @param {*} props
     * @memberof ToolTip
     */
    constructor(props: any) {
        super(props)
        this.state = {
            text: props.text,
            position: props.position ? props.position : 'left',
            verticalPosition: props.verticalPosition ? props.verticalPosition : 'bottom',
        }
    }

    render() {
        return (
            <div className="tooltip">
                <div
                    className="icon"
                    onMouseEnter={() => (this.props.onMouseEnter) ? this.props.onMouseEnter() : null}
                    onMouseLeave={() => setTimeout(
                        () => {
                            if (this.props.onMouseLeave) {
                                this.props.onMouseLeave()
                            }
                        },
                        300
                    )
                    }
                >
                    {(this.props.Accounts) ? (this.props.AccountsBin) ?
                        <BinIcon color={(this.props.color) ? this.props.color : ''} /> : (this.props.paid) ?
                            <img className="MarkPaidTick" src={require('./PaidTick.png')} /> :
                            <img className="MarkPaidTick" src={require('./tick.png')} />
                        : <InfoIcon color={(this.props.color) ? this.props.color : ''} />}
                </div>
                <span
                    className={`tooltiptext tooltiptext__` + this.state.position
                        + ((this.state.verticalPosition) ? `
                         tooltiptext__` + this.state.position + `__` + this.state.verticalPosition
                            : ``)}
                >
                    {this.props.children}
                </span>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/ToolTip/ToolTip.tsx